import React from 'react'

import { LgySubsection } from 'app/components/util/lgy-section/LgySection'

const RequesterInfoSection = ({ assignmentDetails }) =>
  <LgySubsection header='Requester Information' className='assignment-details-child requester-information'>
    <table>
      <caption className='usa-sr-only'>Requester Information</caption>
      <tbody>
        <tr>
          <th scope='row'>Appraisal originator / Requester type:</th>
          <td>{assignmentDetails.requesterType}</td>
        </tr>
        <tr>
          <th scope='row'>Requester name and ID:</th>
          <td>{assignmentDetails.requesterName} – {assignmentDetails.requesterId}</td>
        </tr>
        <tr>
          <th scope='row'>Address:</th>
          <td>{assignmentDetails.requesterAddress}</td>
        </tr>
        <tr>
          <th scope='row'>Lender loan number:</th>
          <td>{assignmentDetails.instituteLoanNumber}</td>
        </tr>
        <tr>
          <th scope='row'>Sponsor name and ID:</th>
          <td>{assignmentDetails.sponsorName} – {assignmentDetails.sponsorCode}</td>
        </tr>
        <tr>
          <th scope='row'>Appraisal requested by:</th>
          <td>{assignmentDetails.pocName}</td>
        </tr>
      </tbody>
    </table>
  </LgySubsection>

export default RequesterInfoSection
